import React from "react";

export type tooltipProps = {
  text?: string;
};

export const Tooltip = (props: tooltipProps) => {
  const { text } = props;

  return <span className="tooltiptext">{text}</span>;
};

Tooltip.defaultProps = {
  text: "Tooltip tex",
};
